/// <amd-module name="Search/Shared/Components/BasePivot" />

import * as React from "react";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { IVssHistoryService, HistoryServiceEventNames, INavigationStateChangedEvent,  } from "VSS/Platform/History";
import { ITabContext } from "Search/Shared/Base/Types";
import { IVssNavigationService } from "VSS/Platform/Navigation";

const SEARCH_PROJECT_ROUTE = "ms.vss-search-web.project-route";
const SEARCH_COLLECTION_ROUTE = "ms.vss-search-web.collection-route";

export class BasePivot extends VssComponent<ITabContext> {
    constructor(props: ITabContext, private type: string, context: IVssComponentContext) {
        super(props, context);
    }

    private onNavigate = (eventData: INavigationStateChangedEvent): void => {
        const historyService = this.context.pageContext.getService<IVssHistoryService>("IVssHistoryService");
        const navigationService = this.context.pageContext.getService<IVssNavigationService>("IVssNavigationService");

        const rawState: { [key: string]: string } = historyService.getState();
        const currentRoute = navigationService.getCurrentRoute().routeId;
        if (currentRoute == SEARCH_PROJECT_ROUTE || currentRoute == SEARCH_COLLECTION_ROUTE) {
            if (this.type == rawState.type) {
                this.onNavigationOccurred(eventData);
            }
        }
    }

    /**
     * Child classes should provide this implementation
     */
    protected onNavigationOccurred = (eventData: INavigationStateChangedEvent): void => {
    }

    /**
     * Child classes should provide this implementation
     */
    public render(): JSX.Element {
        return <></>;
    }

    public componentDidMount(): void {
        this.context
            .pageContext
            .getService<IVssHistoryService>("IVssHistoryService")
            .subscribe(this.onNavigate, HistoryServiceEventNames.statePopped);
    }

    public componentWillUnmount(): void {
        this.context
            .pageContext
            .getService<IVssHistoryService>("IVssHistoryService")
            .unsubscribe(this.onNavigate, HistoryServiceEventNames.statePopped);
    }
}